<template>
  <section class="world-background-green">
    <cards-roulette v-bind:options="options" :type="'business_sectors'" />
  </section>
</template>

<script>
import BusinessSectors from '@/constants/business_sectors.js'
import CardsRoulette from '@/components/on-board/CardsRoulette.vue'
import OnBoardStepMixin from '@/mixins/onBoardStepMixin.js'

export default {
  mixins: [OnBoardStepMixin],
  components: { CardsRoulette },
  data() {
    return {
      options: []
    }
  },
  mounted() {
    const economicSector = this.$store.state.onBoard.neofintech.phase1
      .economicSectors[0]
    this.options = BusinessSectors.filter(function(item) {
      return item.parents.includes(economicSector)
    })
  }
}
</script>
